import {
  DecimalPipe,
  getCurrencySymbol,
  NgIf,
  NgClass,
  NgTemplateOutlet,
  AsyncPipe,
} from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';
import { Observable } from 'rxjs';

import { ExtendedSimulationData } from '../../../models/feed-profit.model';

@Component({
  selector: 'app-extended-simulation-table',
  templateUrl: './extended-simulation-table.component.html',
  styleUrls: ['./extended-simulation-table.component.scss'],
  imports: [NgIf, NgClass, MatIcon, NgTemplateOutlet, AsyncPipe, TranslatePipe],
})
export class ExtendedSimulationTableComponent implements OnInit {
  @Input() extendedSimulationData$: Observable<ExtendedSimulationData>;
  displayedColumns: string[] = ['type', 'comparison', 'extended'];

  currencySymbol: string;

  constructor(
    private readonly localeService: LocaleService,
    private readonly decimalPipe: DecimalPipe,
  ) {}

  ngOnInit() {
    this.currencySymbol = getCurrencySymbol(this.localeService.getCustomerCurrency(), 'narrow');
  }

  getDataRow(
    type: string,
    unitOfMeasurement: string,
    value: number,
    comparisonValue: number,
    differenceDigits = '1.0-2',
    valueDigits = '1.0-2',
  ) {
    const diff = this.getDifferenceValue(value, comparisonValue, differenceDigits);

    return {
      type,
      unitOfMeasurement,
      extended: this.getValue(value, valueDigits),
      comparison: this.getValue(comparisonValue, valueDigits),
      diff,
      digitsInfo: valueDigits,
      isPositive: this.isPositive(diff),
    };
  }

  getDifferenceValue(value: number, comparisonValue: number, digitsInfo = '1.0-2') {
    const diff = value && comparisonValue ? value - comparisonValue : null;

    return this.getValue(diff, digitsInfo);
  }

  isPositive(text: string): number {
    const parsedText = parseFloat(text?.replace(',', '.')) * 100;
    return parsedText > 0 ? 1 : parsedText < 0 ? -1 : 0;
  }

  getValue(value: unknown, digitsInfo = '1.0-2') {
    if (
      value === undefined ||
      value === null ||
      value === '' ||
      isNaN(parseFloat(value as string)) ||
      !isFinite(parseFloat(value as string))
    ) {
      return this.localeService.translate('n/a');
    }
    return this.decimalPipe.transform(
      value as unknown as string,
      digitsInfo,
      this.localeService.getLocale(),
    );
  }
}
